<template>
  <div class="job-detail" v-if="postDetail && postDetail.id">
    <h1 class="job-detail-title">
      <span>{{ postDetail.name }} </span>
      <el-tooltip :content="likeTooltip" effect="light" placement="top-start">
        <i :class="ifLike? 'el-icon-star-on': 'el-icon-star-off'" :style="likeStyle" @click="likeOrNot"></i>
      </el-tooltip>

      <ghidri-back />
    </h1>

    <div class="job-detail-subTitle">
     <span style="width: 80%">
        <span>{{ postDetail.categoryTimeName }}</span>

        <span style="margin: 0px 5px;" v-if="postDetail.deadline">|</span>
        <span v-if="postDetail.deadline">{{ postDetail.deadline }}</span>
      </span>
    </div>

    <div class="job-detail-description job-detail-block" v-if="postDetail.majorTarget">
      <h2>专业方向</h2>
      <pre class="textContent">{{ postDetail.majorTarget }}</pre>
    </div>

    <div class="job-detail-description job-detail-block" v-if="postDetail.majorType">
      <h2>专业类别</h2>
      <pre class="textContent">{{ postDetail.majorType }}</pre>
    </div>

    <div class="job-detail-requirement job-detail-block">
      <h2>课题单位</h2>
      <span>{{ postDetail.deptName }}</span>
    </div>

    <div class="job-detail-block">
      <el-badge :value="cartCount" :max="99" type="primary">
        <ghidri-button @click="onAddCartClicked" size="large" type="danger" class="job-detail-button add-cart">加入投递箱</ghidri-button>
      </el-badge>
      <ghidri-button @click="onDeliveryClicked" size="large" class="job-detail-button apply">立即申请</ghidri-button>
    </div>
  </div>
</template>

<script>
  import doctorPostApi from "@/api/doctor/doctorPost.js";
  import doctorCartApi from "@/api/doctor/doctorCart.js";

  import favoriteApi from "@/api/favorite.js";

  import store from "@/store";

  export default {
    name: "SocietyCartBefore",
    data() {
      return {
        postDetail: {},
        ifLike: false,
        cartCount: "",  /*投递数量*/
      };
    },
    created() {
      const id = this.$route.params.id
      this.init(id);
    },
    computed: {
      likeStyle() {
        if (this.ifLike) {
          return {
            color: "red",
            cursor: "pointer"
          };
        } else {
          return {
            color: "black",
            cursor: "pointer"
          };
        }
      },
      likeTooltip() {
        if (this.ifLike) {
          return "取消收藏";
        }
        return "点击收藏";
      },
      categoryCode() {
        return store.getters.category.doctor;
      },
      categoryTimeId() {
        const categoryTimeList = store.getters.categoryTimeList;
        for (var i = 0; i < categoryTimeList.length; i++) {
          if (store.getters.category.doctor == categoryTimeList[i].categoryCode) {
            return categoryTimeList[i].id;
          }
        }
        return "";
      },
    },
    methods: {
      init(id) {
        const _this = this;
        let loading = _this.$loading({ position: { top: 60 } });
        doctorPostApi.getPostById(id).then(res => {
          if (res.success) {
            _this.postDetail = res.data;

            //获取当前用户投递箱职位数量
            doctorCartApi.count().then(res => {
              _this.cartCount = res.data === 0 ? "" : res.data;
            });

            //判断当前用户是否收藏该产品
            favoriteApi.ifLike(_this.postDetail.id).then(res => {
              if (res.data === true) {
                _this.ifLike = true;
              }
            });
          }

          loading.close();
        }).catch(loading.close);
      },

      //去投递箱
      goToCart() {
        this.$router.push('/doctor/cart');
      },

      //立即申请
      onDeliveryClicked() {
        const _this = this;
        const callback = function(res) {
          _this.$message.warning(res.msg);
          _this.goToCart();
        }
        _this.addToCart(callback);
      },

      //加入投递箱
      onAddCartClicked() {
        const _this = this;
        const callback = function(res) {
          _this.$message.success(res.msg);
          _this.cartCount += res.data;
        }
        _this.addToCart(callback);
      },

      addToCart(cb) {
        const _this = this;
        const cartData = _this.getCheckedItems();
        if (cartData.length === 0) {
          _this.$message.warning("请选择投递单位");
          return false;
        }

        doctorCartApi.add(cartData).then(res => {
          if (res.success) {
            cb(res);
          }
        }).catch((err) => {
          console.log("err", err);
          _this.$message.error(err || "网络出错，请稍后再试");
        });
      },

      getCheckedItems() {
        const checkedObj = []
        checkedObj.push({
          postId: this.postDetail.id,
          postName: this.postDetail.name,
          deptId: this.postDetail.deptId,
          deptName: this.postDetail.deptName,
          categoryTimeId: this.categoryTimeId,
          categoryCode: this.categoryCode,
        })
        return checkedObj;
      },

      likeOrNot() {
        const _this = this;
        if (_this.ifLike === false) {
          favoriteApi.add(_this.postDetail.id).then(res => {
            _this.$message.success("收藏成功");
            _this.ifLike = true;
          }).catch((err) => {
            console.log("err", err);
            _this.$message.error(err || "网络出错，请稍后再试");
          });
        } else {
          favoriteApi.disLike(_this.postDetail.id).then(res => {
            _this.$message.success("取消收藏");
            _this.ifLike = false;
          }).catch((err) => {
            console.log("err", err);
            _this.$message.error(err || "网络出错，请稍后再试");
          });
        }
      },

      backEvent() {
        this.$router.go(-1);
      },

    }
  };
</script>

<style lang="less" scoped>
  .job-detail {
    width: 800px;
    height: calc(100vh - 400px);

    margin: auto;
    margin-top: 30px;
    line-height: 2em;

    &-subTitle {
      font-size: @font-size-base;
      color: @primary-text-color;
      margin: 10px 0;
    }

    &-description {
      .textContent {
        white-space: pre-line;
      }
    }

    &-block {
      h2 {
        margin-bottom: 20px;
      }

      margin: 40px 0;

      .textContent {
        font-size: @font-size-base;
        color: @primary-text-color;
      }

      .major {
        white-space: pre-line;
        font-size: 20px;
        color: @secondary-text-color;
        .text-overflow-visible-line(2);
        text-overflow: clip;
      }

      .major a {
        display: inline-block;
        height: 40px;
        padding: 0 10px;
        line-height: 38px;
        font-size: 20px;
        border-width: 1px;
        border-style: solid;
        border-radius: 4px;
        box-sizing: border-box;
        margin: 10px;
        background-color: #f4f4f5;
        border-color: #e9e9eb;
        color: #909399;
        cursor: pointer;
      }
    }

    &-button {
      display: inline-flex;
      width: 200px;
    }

    .add-cart {
      float: left;
    }

    .apply {
      float: right;
    }
  }
</style>
